import { render, staticRenderFns } from "./product-tab.vue?vue&type=template&id=0e9da02c&scoped=true"
import script from "./product-tab.vue?vue&type=script&lang=js"
export * from "./product-tab.vue?vue&type=script&lang=js"
import style0 from "./product-tab.vue?vue&type=style&index=0&id=0e9da02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9da02c",
  null
  
)

export default component.exports